import styled from 'styled-components';
import type { OTabContainerAlignment } from './OTabContainer.types';

interface WrapperProps {
  alignment?: OTabContainerAlignment;
}

export const Wrapper = styled.div`
  width: 100%;
  padding: 3rem 0;

  @media (min-width: 768px) {
    padding: 4rem 0;
  }

  @media (min-width: 992px) {
    padding: 5rem 0;
  }
`;

export const ContentHeaderWrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-bottom: 2rem;
  text-align: ${({ alignment }) => (alignment === 'Center' ? 'center' : 'left')};
  align-items: ${({ alignment }) => (alignment === 'Center' ? 'center' : 'flex-start')};

  @media (min-width: 992px) {
    margin-bottom: 3rem;
    gap: 2rem;
  }
`;

export const ButtonGroup = styled.div<WrapperProps>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  @media (min-width: 768px) {
    flex-direction: row;
    width: auto;
    justify-content: ${({ alignment }) => (alignment === 'Center' ? 'center' : 'flex-start')};
  }
`;

export const TabControlsWrapper = styled.div<WrapperProps>`
  margin-bottom: 2rem;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: 992px) {
    overflow-x: visible;
  }
`;

export const TabControlsList = styled.div<WrapperProps>`
  display: flex;
  gap: 0.5rem;
  min-width: min-content;
  justify-content: ${({ alignment }) => (alignment === 'Center' ? 'center' : 'flex-start')};

  @media (min-width: 768px) {
    gap: 1rem;
  }

  @media (min-width: 992px) {
    gap: 1.5rem;
  }
`;

export const TabControlItem = styled.button<{ isActive: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  border: none;
  background-color: ${({ isActive }) => (isActive ? 'var(--t-brand-bg-color)' : 'transparent')};
  color: ${({ isActive }) => (isActive ? 'var(--t-brand-fg-color)' : 'var(--t-brand-alt-color)')};
  border-bottom: ${({ isActive }) =>
    isActive ? '4px solid var(--t-accent-color)' : '4px solid transparent'} !important;
  cursor: pointer;
  white-space: nowrap;
  min-width: fit-content;

  &:hover {
    background-color: var(--t-brand-bg-color);
    color: var(--t-brand-fg-color);
  }

  &:focus-visible {
    outline: 2px solid var(--t-accent-color);
    outline-offset: 2px;
  }

  @media (min-width: 768px) {
    flex-direction: column;
    gap: 0.75rem;
  }

  @media (min-width: 992px) {
    gap: 1rem;
  }
`;

export const TabLabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  text-align: center;

  @media (min-width: 768px) {
    text-align: left;
  }
`;

export const TabContentWrapper = styled.div`
  width: 100%;
  min-height: 200px;
`;
